import { GroupListState, initialGroupListState } from './group-list.state';
import {
  CurrentGroupState,
  initialCurrentGroupState
} from './current-group.state';

export interface GroupsState {
  groupList: GroupListState;
  currentGroup: CurrentGroupState;
}

export const initialGroupsState: GroupsState = {
  groupList: initialGroupListState,
  currentGroup: initialCurrentGroupState
};
